import { IReactQuillDelta } from '../APIPackage/KnmModule/interfaces/IReactQuillDelta';
import { removeTrailingNewline } from './removeTrailingNewline';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const handleReactQuillDeltaValue = (value: IReactQuillDelta | string | null | undefined): any => {
  if (value == null) {
    return value;
  }

  if (typeof value === 'string') {
    if (value === '') {
      return { ops: [] };
    }

    return { ops: [{ insert: value }] };
  }

  return removeTrailingNewline(value);
};
